import React from 'react';
import Navbar from '../../components/Navbar';
import StudyCreate from '../../components/Study/StudyCreate';
import './StudyCreatePage.css';

const StudyCreatePage = () => {
  return (
    <div className="study-create-page">
      <Navbar />
      <div className="study-create-content">
        <h2>New Study</h2>
        <StudyCreate />
      </div>
    </div>
  );
};

export default StudyCreatePage;
